// var lm_button = document.querySelector("#shopify-section-template--16511944589534__rich_text_GK7Qrw .isolate .rich-text .rich-text__wrapper .rich-text__blocks .rich-text__buttons a");
// var lm_text = document.querySelector("#shopify-section-template--16511944589534__rich_text_GK7Qrw .isolate .rich-text .rich-text__wrapper .rich-text__blocks .rich-text__text p");

// // Hide the content initially
// lm_text.style.opacity = "0";
// lm_text.style.display = "none";

// lm_button.addEventListener("click", function(event) {
//     event.preventDefault(); // Prevent the default behavior of the anchor element

//     // Toggle fade effect on text
//     if (lm_text.style.opacity === "0") {
//         fadeIn(lm_text);
//         lm_button.textContent = "Read Less";
//     } else {
//         fadeOut(lm_text);
//         lm_button.textContent = "Learn More";
//     }
// });

// shopify-section-template--16511944589534__rich_text_ejXXeX

var commitment_button = document.querySelector("#shopify-section-template--16511944589534__rich_text_ejXXeX .isolate .rich-text .rich-text__wrapper .rich-text__blocks .rich-text__buttons a");
var commitment_text = document.querySelector("#shopify-section-template--16511944589534__rich_text_ejXXeX .isolate .rich-text .rich-text__wrapper .rich-text__blocks .rich-text__text");

// Hide the content initially
commitment_text.style.opacity = "0";
commitment_text.style.display = "none";

commitment_button.addEventListener("click", function(event) {
    event.preventDefault(); // Prevent the default behavior of the anchor element

    // Toggle fade effect on text
    if (commitment_text.style.opacity === "0") {
        fadeIn(commitment_text);
        commitment_button.textContent = "Read Less";
    } else {
        fadeOut(commitment_text);
        commitment_button.textContent = "Learn More";
    }
});


function fadeIn(element) {
    element.style.display = "block";
    setTimeout(function() {
        element.style.transition = "opacity 0.5s";
        element.style.opacity = "1";
    }, 10); // Delay to ensure transition effect is applied
}

function fadeOut(element) {
    element.style.transition = "opacity 0.5s";
    element.style.opacity = "0";
    setTimeout(function() {
        element.style.display = "none";
    }, 500); // Delay to match the transition duration
}
